import { render, staticRenderFns } from "./ForgotPasswordReset.vue?vue&type=template&id=3285c521&scoped=true"
import script from "./ForgotPasswordReset.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordReset.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordReset.vue?vue&type=style&index=0&id=3285c521&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3285c521",
  null
  
)

export default component.exports